import { render, staticRenderFns } from "./RangeRadios.vue?vue&type=template&id=24878874"
import script from "./RangeRadios.vue?vue&type=script&lang=js"
export * from "./RangeRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports